import React from 'react';
import { Modal } from 'react-bootstrap';
import WBkey from '../WBkey';

export default function ModalAlliances({ handleClose, active }) {
	return (
		<Modal
			show={active.status}
			onHide={handleClose}
			size='lg'
			className='modal-aalliances'
		>
			<Modal.Header closeButton></Modal.Header>
			<Modal.Body className='headerModal'>
				<img src={active.image} alt='logo' />
				{active.number === '1' && <JstorBody />}
				{active.number === '2' && <FamilyBody />}
				{active.number === '3' && <WichitecaBody />}
				<a
					className='btn btn-outline-primary'
					href={active.location}
					target='_blank'
					rel='noreferrer'
				>
					{/* <WBkey wbkey='aRtadJcP' /> */}
					Ir al sitio web
				</a>
			</Modal.Body>
		</Modal>
	);
}

function JstorBody() {
	return (
		<div class='text-left'>
			<span wbk='13noPtGK'>
				<p>
					JSTOR es un sistema de almacenamiento en línea de
					publicaciones académicas que fue fundado en 1995.
				</p>

				<p>
					Durante la pandemia, JSTOR ha permitido a varias
					instituciones educativas y culturales como CIRMA contar con
					un acceso gratuito para sus usuarios por tiempo limitado.
					Aprovecha e ingresa a nuestra página web y consulta los
					miles de artículos académicos disponibles.
				</p>

				<p>
					CIRMA agradece a dot.lib el acceso temporal gratuito a JSTOR
					para apoyar la investigación durante la pandemia. Ingrese a
					https://www.jstor.org y haga clic en Log in.
				</p>
			</span>
			<p class='neg mb-0'>
				<span wbk='OLHvz82j'>Datos de acceso:</span>
			</p>
			<p class='mb-0'>
				<span wbk='Gd74QNgD'>1. usuario: CIRMA</span>
			</p>
			<p class='mb-0'>
				<span wbk='Yty0qO1w'>2. Contraseña: investigacion</span>
			</p>
		</div>
	);
}

/* <div className='text-left'>
	<WBkey wbkey='13noPtGK' />
	<p className='neg mb-0'>
		<WBkey wbkey='OLHvz82j' />
	</p>
	<p className='mb-0'>
		<WBkey wbkey='Gd74QNgD' />
	</p>
	<p className='mb-0'>
		<WBkey wbkey='Yty0qO1w' />
	</p>
</div> */

function FamilyBody() {
	return (
		<div className='text-left'>
			<span wbk='Q_Rw1gi6'>
				<p>
					Es una organización internacional sin fines de lucro que
					ofrece herramientas gratuitas para ayudarte a descubrir tu
					genealogía.
				</p>

				<p>
					La Biblioteca de Ciencias Sociales de CIRMA cuenta con la
					primera terminal de FamilySearch con acceso directo a su
					base de datos principal, la cual contiene miles de millones
					de registros adicionales a los disponibles en su aplicación
					o sitio web. Dale vida a la historia de tus antepasados.
					¡Visita CIRMA y descubre tu historia familiar!
				</p>
			</span>
		</div>
	);
}

function WichitecaBody() {
	return (
		<div className='text-left'>
			<span wbk='YNhaRyqM'>
				<p>
					Wichiteca es el catálogo unificado de diversas bibliotecas
					académicas de Guatemala. Nace de un esfuerzo por integrar el
					acceso al conocimiento&nbsp;tanto para estudiantes e
					investigadores como la sociedad en general. Conoce más
					acerca de este proyecto.
				</p>
			</span>
		</div>
	);
}
